import { ThemeProvider } from "styled-components";
import { MuiThemeProvider, StylesProvider } from "@material-ui/core";
import theme from "./config/theme";
import GlobalStyle from "./styles/global";
import { ToastContainer } from "react-toastify";
import RoutesWrapper from "routes/RoutesWrapper";
import { BrowserRouter } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <StylesProvider injectFirst>
        <MuiThemeProvider theme={theme}>
          <ThemeProvider theme={theme}> 
            <RoutesWrapper />
            <GlobalStyle />
            <ToastContainer autoClose={3000} />
          </ThemeProvider>
        </MuiThemeProvider>
      </StylesProvider>
    </BrowserRouter>
  );
}

export default App;
